import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponseObject } from '@interfaces/api-response/1.0';
import { Observable } from 'rxjs';

/** Options for paginated HTTP requests (first page, headers, optional fixed page size). */
export interface PaginationRequestOptions {
  headers?: HttpHeaders;
  params?: any;
  /** When set, used as `size` for the first request and enforced on every `next` URL. */
  pageSize?: number;
}

@Injectable({
  providedIn: 'root',
})
export abstract class PaginationAbstractService {
  abstract fetchAllPages<T extends ApiResponseObject>(
    url: string,
    options?: PaginationRequestOptions,
  ): Observable<T>;
  abstract fetchPage<T extends ApiResponseObject>(
    url: string,
    options?: PaginationRequestOptions,
  ): Observable<T>;
}
